import { Box, Button, Modal, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { setRefreshToken } from '../../utilities/AuthService';
import './index.css';

interface TimeoutModalProps {
  open: boolean;
  handleCloseTimeoutModal: () => void;
  logout: () => void;
}

function TimeoutModal({ open, handleCloseTimeoutModal, logout }: TimeoutModalProps): JSX.Element {
  const seconds = parseInt(import.meta.env.VITE_APP_ABOUT_TO_LOG_OUT_FOR_INACTIVITY_IN_SECONDS || '');
  const [timeLeft, setTimeLeft] = useState(seconds);

  const onClickRefreshToken = async () => {
    await setRefreshToken();
    handleCloseTimeoutModal();
    setTimeLeft(seconds);
  };

  useEffect(() => {
    if (open) {
      const intervalId = setInterval(() => {
        setTimeLeft((t) => t - 1);
        if (timeLeft <= 0) {
          setTimeLeft(-1);
          logout();
        }
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [timeLeft, logout, open]);

  return (
    <>
      <Modal open={open} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description' disableEnforceFocus>
        <Box className='app-modal-box'>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Rules Engine Session
          </Typography>
          <Typography id='modal-modal-description'>Your session is about to expire in less than {timeLeft} seconds due to inactivity.</Typography>
          <Button onClick={onClickRefreshToken} color='primary'>
            Stay Logged In
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default TimeoutModal;
